import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

export interface ButtonList{
    description:string;
    icon?:string;
    disabled?:boolean;
    color:string;
    action:(data)=> void;
}

@Component({
    selector: 'actions-buttons',
    templateUrl: './actions-buttons.component.html',
    styleUrls: ['./actions-buttons.component.scss'],
    standalone: false
})

export class ActionsButtonsComponent implements OnInit, OnChanges  {
  

  @Input()  buttonList;

  @Input() data:any;
  
  constructor() { }
  
  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  
  
}
